import { createRoot } from 'react-dom/client'
import DisneyApp from './components/DisneyApp'
import './style/global.css'
import './style/disneyUi.css'

function App() {
  return (
      <DisneyApp />
  )
}

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container)
root.render(<App />)